import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import UserServices from "../services/UserServices";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [alert, setAlert] = useState("");
    const navigate = useNavigate();


    const handleSubmit = async (event) => {
        event.preventDefault();
        let user = ''
        if (username !== "" && password !== "") {
            user = {
                username: username,
                password: password
            }

            UserServices.Login(user.username, user.password).then(data => {
                user = data['data'];
                setAlert("");
                setMessage("Tentative de connexion en cours...");
                if (data['success'] === true) {
                    localStorage.setItem('token', user.id);
                    localStorage.setItem('created_by', user.id);
                    localStorage.setItem('role', user.role_id);
                    localStorage.setItem('username', user.username);
                    navigate('/user');
                } else if (data['success'] === false) {
                    setMessage("");
                    setUsername("");
                    setPassword("");
                    setAlert(data['message']);
                }
            });

            // AuthenticatorServices.login(user.email, user.password).then(isAuthenticated => {
            //     if (!isAuthenticated) {
            //         setMessage("Identifiant ou Mot de passe incorrect.");
            //         return;
            //     }
            //     localStorage.setItem('token', user.email);
            //     localStorage.setItem('role', user.role);
            //     navigate('/user');
            // });
        }
        else {
            setAlert("Veuillez remplir tous les champs.");
            return false;
        }

    };

    return (
        <div className="container">
            <div className="row">

                {message && <div className="alert alert-warning mt-1">{message}</div>}
                {alert && <div className="alert alert-danger mt-1">{alert}</div>}
                <div className="col-md-4"></div>
                <div className="col-md-4">
                    <p>ousmanediallo / P@ssword123</p>
                    <h3 className="text-center mb-3">Se connecter</h3>
                    <Form onSubmit={handleSubmit} className="mb-4">
                        <Form.Group controlId="formBasicUsername" className="mb-4">
                            <Form.Control
                                type="text"
                                placeholder="Entrer le nom d'utilisateur"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required={true}
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicPassword" className="mb-4">
                            <Form.Control
                                type="password"
                                placeholder="Entrer le mot de passe"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required={true}
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Se connecter
                        </Button>
                    </Form>
                    <Link to="/forget-password" className="">Mot de passe oublié</Link>
                </div>
                <div className="col-md-4"></div>
            </div>
        </div>
    );
};

export default Login;
